/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 230,
    height: 230,
    viewBox: '0 0 230 230',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" _fill="#FFC001" cx="115" cy="115" r="115"/><path pid="1" d="M63.465 82H167M37.5 115h155.705M63.465 148H167" _stroke="#1D7F8A" stroke-width="4" stroke-linecap="square"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/menu.js